import { useState } from "react";
import DependenciesView from "../../../DependenciesView";
import AppSidebar, { SB_W, SB_W_COLLAPSED } from "../../../AppSidebar";
import "../../../V2SideDrawer.css";
import "../styles/DependenciesViewV2Page.css";

export default function DependenciesViewV2Page({ showToast, user }) {
  const [sidebarCollapsed, setSidebarCollapsed] = useState(
    () => localStorage.getItem("sb-collapsed") === "true"
  );

  return (
    <div
      className="depv2-root"
      style={{ gridTemplateColumns: sidebarCollapsed ? `${SB_W_COLLAPSED} 1fr` : `${SB_W} 1fr` }}
    >
      <AppSidebar
        user={user}
        collapsed={sidebarCollapsed}
        onCollapse={() => setSidebarCollapsed((c) => {
          const next = !c;
          localStorage.setItem("sb-collapsed", String(next));
          return next;
        })}
      />

      <div className="depv2-main">
        <DependenciesView showToast={showToast} user={user} />
      </div>
    </div>
  );
}
